<template>
    <div class="modal fade" id="modal_add_promotion" tabindex="-1" data-bs-backdrop='static' aria-hidden="true">

        <div class="modal-dialog modal-lg">
            <div class="modal-content position-relative">
                <loader-gif v-if="isRequestPromoPack" />
                <div class="modal-header">
                    <h5 class="modal-title" id="varyingModalLabel">
                        {{ action == 'add' ? i18n.t('views.clients.promotions.add') :
                            i18n.t('views.clients.promotions.edit') }}
                    </h5>
                    <button @click="closeModal('modal_add_promotion', 'add')" type="button" class="btn-close"
                        aria-label="btn-close"></button>
                </div>
                <div class="modal-body" v-if="requestPromoPack">
                    <form class="forms-sample" @submit.prevent="submitForm">
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestPromoPack.name" :label="i18n.t('tables.promotions.name')"
                                :v="v$.name" :disabled="false" />
                        </div>
                        <div class="form-group mr-b-0em">
                            <inputText v-model="requestPromoPack.description"
                                :label="i18n.t('tables.promotions.description')" :v="v$.description"
                                :disabled="false" />
                        </div>

                        <div class="form-group mr-b-0em">
                            <date-field v-model="requestPromoPack.start_date"
                                :label="i18n.t('tables.promotions.start_date')" :v="v$.start_date" :disabled="false"
                                :fixedDays="1" :isFixedDays="true" />
                        </div>
                        <div class="form-group mr-b-0em">
                            <date-field v-model="requestPromoPack.end_date"
                                :label="i18n.t('tables.promotions.end_date')" :v="v$.end_date" :disabled="false" />
                        </div>
                        <div class="form-group mr-b-0em">

                            <price-input v-model="requestPromoPack.price" :label="i18n.t('tables.promotions.price')"
                                :v="v$.price" :disabled="false" />
                        </div>
                        <div class="form-group mr-b-0em">
                            <SingleSelect :TextLabel="i18n.t('tables.subscription_member.pack_id')" :trackby="`id`"
                                :label="`name`" :valueProp="`id`" v-model="requestPromoPack.pack_id"
                                :placeholder="i18n.t('tables.subscription_member.pack_id')" :arrayOptions="packsList"
                                refs="packs" :v="v$.pack_id" />
                        </div>

                        <div class="col-12 text-right">
                            <button type="submit" class="btn btn-primary mr-2">

                                {{ action == 'add' ? i18n.t('button.add') : i18n.t('button.edit') }}
                            </button>
                            <button type="button" @click="emptyState()" class="btn btn-cancel">

                                {{ i18n.t('button.clean') }}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>

</template>

<script lang="ts">
import { defineComponent, ref, computed, toRefs, watch } from "vue";
/*Components*/
import inputText from "@/components/inputsValidation/ReusableInput.vue";
import inputFilter from "@/components/inputsValidation/inputFilter.vue";
import SingleSelect from "@/components/inputsValidation/SingleSelect.vue";

/*plugins*/
import { useVuelidate } from "@vuelidate/core";
import { required, numeric, minLength, helpers } from "@vuelidate/validators";
import Swal from "sweetalert2";
import i18n from "@/i18n/index"
import { useRouter } from 'vue-router'; // Import useRouter
/*composables & states */
import { useModal } from '@/composables/modal/useModal';

import { usePromoPack } from "@/composables/promoPack/usePromoPack";
import { clubUUID, packs } from "@/shared/state";
import { PromoPackRequest } from "@/interfaces/promoPack";
import { usePermission } from "@/composables/auth/usePermission";

export default defineComponent({
    components: { inputText, inputFilter, SingleSelect },
    name: "Some-Component",
    props: {
        promotion: {
            type: Object,
            default: null,
        }
    },
    setup(props) {
        const action = ref('add')
        const { promotion } = toRefs(props);
        const { closeModal } = useModal();

        const requestPromoPack = ref<PromoPackRequest>({
            id: null,
            name: null,
            description: null,
            price: null,
            start_date: null,
            pack_id: null,
            end_date: null
        });
        const packsList = computed(() => packs.data);
        const { addPromoPack, editPromoPack, isRequestPromoPack, errorPromoPack } = usePromoPack();
        const { hasPermission } = usePermission();

        // Validation
        const rules = {

            name: {
                required: helpers.withMessage(i18n.t("validation.required"), required), String,
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                ),
            },
            description: {
                required: helpers.withMessage(i18n.t("validation.required"), required), String,
                minLength: helpers.withMessage(
                    i18n.t("validation.min.string", { value: 2, attribute: '' }),
                    minLength(2)
                ),
            },
            price: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },

            start_date: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            end_date: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            },
            pack_id: {
                required: helpers.withMessage(i18n.t("validation.required"), required),
            }
        };
        const v$ = useVuelidate(rules, requestPromoPack, { $scope: 'promotions' });
        /**
         * Add or edit announcement
         */
        const submitForm = async () => {
            v$.value.$touch();
            if (!v$.value.$invalid) {
                if (action.value === "add") {
                    await addPromoPack(requestPromoPack.value);
                    if (!errorPromoPack.value)
                        emptyState()
                } else {
                    Swal.fire({
                        title: i18n.t("message.confirmation.edit.title"),
                        icon: "warning",
                        showCancelButton: true,
                        confirmButtonColor: "#3085d6",
                        cancelButtonColor: "#d33",
                        confirmButtonText: i18n.t("button.edit"),
                        cancelButtonText: i18n.t("button.cancel"),
                        allowOutsideClick: false,   // ✅ disable closing by clicking outside
                        allowEscapeKey: false       // (optional) disable closing with ESC
                    }).then(async (result) => {
                        if (result.isConfirmed) {
                            if (action.value == "add") {
                                await addPromoPack(requestPromoPack.value)
                                if (!errorPromoPack.value)
                                    closeModal('modal_add_promotion', 'add')
                            } else if (action.value == "edit") {
                                await editPromoPack(requestPromoPack.value)
                                if (!errorPromoPack.value)
                                    closeModal('modal_add_promotion', 'add')
                            }
                        }
                    });
                }
            }
        }

        const emptyState = () => {
            action.value = 'add';
            requestPromoPack.value.id = null
            requestPromoPack.value.name = null
            requestPromoPack.value.description = null
            requestPromoPack.value.price = null
            requestPromoPack.value.pack_id = null
            requestPromoPack.value.start_date = null
            requestPromoPack.value.end_date = null
            closeModal('modal_add_promotion', 'add')
            v$.value.$reset();
        };
        const initState = (announcement) => {
            if (announcement?.id) {
                action.value = 'edit';
                requestPromoPack.value.id = announcement?.id || null
                requestPromoPack.value.name = announcement?.name || null
                requestPromoPack.value.description = announcement?.description || null
                requestPromoPack.value.price = announcement?.price || null
                requestPromoPack.value.start_date = announcement?.start_date || null
                requestPromoPack.value.end_date = announcement?.end_date || null
                requestPromoPack.value.pack_id = announcement?.pack_id || null
                v$.value.$reset();
            } else {
                emptyState()
            }
        };

        watch(
            () => promotion.value,
            (newValue) => {
                initState(promotion.value)

            });

        return {
            requestPromoPack,
            submitForm,
            initState,
            emptyState,
            action,
            v$,
            i18n,
            hasPermission,
            isRequestPromoPack,
            closeModal,
            packsList
        };
    },
});
</script>
